import { ComparatorEnum } from '../../../models/interface/comparator.enum';
import { PermissionSameNextDayOption } from '../keys/permissionSameNextDay.enum';
import { PermissionOption } from '../models/permissionOption.interface';

export const PermissionSameNextDay: PermissionOption[] = [
  {
    code: 'P200',
    option: PermissionSameNextDayOption.SAME_NEXT_DAY_COMMON_LOGIN,
    permissions: ['same-next-day.common.login'],
    comparator: ComparatorEnum.EXACT,
  },
  {
    code: 'P201',
    option: PermissionSameNextDayOption.SAME_NEXT_DAY_LIST,
    permissions: ['same-next-day.package.list'],
    comparator: ComparatorEnum.STARTS_WITH,
  },
  {
    code: 'P202',
    option: PermissionSameNextDayOption.SAME_NEXT_DAY_SHOW_DETAIL,
    permissions: ['same-next-day.package.showDetail'],
    comparator: ComparatorEnum.STARTS_WITH,
  },
  {
    code: 'P203',
    option: PermissionSameNextDayOption.SAME_NEXT_DAY_SHOW_NEW_DETAIL,
    permissions: ['same-next-day.package.showNewDetail'],
    comparator: ComparatorEnum.STARTS_WITH,
  },
];
